import React from "react";

import LegalPageLayout from "@/components/LegalPageLayout";
import {
  HOME_META,
  REGULATION_PAGE_INTRO,
  REGULATION_SECTIONS,
  REGULATION_SUMMARY_CARDS,
  REGULATION_PATH,
} from "@/content/siteContent";
import { usePageSEO } from "@/hooks/usePageSEO";

export default function RegulationPage() {
  usePageSEO({
    title: "Regolamento Fanta Royal",
    description:
      "Consulta il regolamento sintetico di Fanta Royal: quota di iscrizione, premi, meccaniche della competizione, regole di condotta e note organizzative.",
    canonicalPath: REGULATION_PATH,
    keywords: `${HOME_META.keywords}, regolamento fanta royal`,
  });

  return (
    <LegalPageLayout
      kicker="Regolamento"
      title="Regolamento di Fanta Royal"
      intro={REGULATION_PAGE_INTRO}
      summaryCards={REGULATION_SUMMARY_CARDS}
      sections={REGULATION_SECTIONS}
      ctaLabel="Vai al ticket"
      pdfDownloadUrl="/FantaRoyal_Regolamento_Ufficiale.pdf"
    />
  );
}
